import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import ServicesGrid from './components/ServicesGrid';
import AdditionalServices from './components/AdditionalServices';

const ProductsServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroBanner />
      <ServicesGrid />
      <AdditionalServices />
      <Footer />
    </div>
  );
};

export default ProductsServicesPage;